import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'pulse',
});

export const getTechnologyRouteRef = createSubRouteRef({
  id: 'get-technology',
  parent: rootRouteRef,
  path: '/technologies/:technologyId',
});

export const getProjectRouteRef = createSubRouteRef({
  id: 'get-project',
  parent: rootRouteRef,
  path: '/projects/:projectId',
});
